module.exports = __webpack_public_path__ + "assets/img/fazhan1.148d285c.jpg";